export default function ({ redirect, route }) {
    if (route.name === "blog" && process.env.APP_TITLE === "SuperWin") {
        redirect("/")
    }
}
